import { render, staticRenderFns } from "./EmergencyOrderContainerViewButton.vue?vue&type=template&id=0dd1ae99"
import script from "./EmergencyOrderContainerViewButton.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderContainerViewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports